import { useEffect, useState } from 'react';

export const useIsReactNativeWebView = () => {
  const [isWebview, setIsWebview] = useState<boolean>(true);

  useEffect(() => {
    if (navigator?.userAgent.indexOf('reactNativeWebview') === -1) {
      setIsWebview(false);
    }
  }, []);

  return isWebview;
};

export const getReactNativeXNsClient = (version: string) => {
  if (
    typeof navigator !== 'undefined' &&
    navigator.userAgent.indexOf('reactNativeWebview') !== -1
  ) {
    const isAndroid = navigator.userAgent.includes('reactNativeWebviewAndroid');
    const appVersion = navigator.userAgent.match(
      /reactNativeAppVersion=([^;]*);/
    )?.[1];

    return `app=wallet; platform=mobile; brand=netspend; platformType=${
      isAndroid ? 'android' : 'ios'
    }; version=${appVersion ? appVersion : version}`;
  }
  return;
};
